
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surf-forecasts/[subregionSlug]/[subregionId]",
      function () {
        return require("private-next-pages/surf-forecasts/[subregionSlug]/[subregionId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surf-forecasts/[subregionSlug]/[subregionId]"])
      });
    }
  